export const EmptyState = ({ label = "Coming soon", note, dark = false }) => (
  <>
    {[0, 1, 2].map((i) => (
      <div
        key={i}
        data-testid="empty-state-card"
        className={`border ${dark ? "border-white/15" : "border-[#E8E4D9]"} p-8 h-[260px] flex flex-col justify-between`}
      >
        <div className={`w-full h-28 ${dark ? "bg-white/5" : "bg-[#1A1713]/[0.03]"}`} />
        <div>
          <p className="text-[10px] uppercase tracking-[0.25em] text-[#C5A059]">{label}</p>
          <p className={`text-sm mt-2 ${dark ? "text-[#FDFBF7]/50" : "text-[#78716C]"}`}>
            {note || "This space is reserved and will be published shortly."}
          </p>
        </div>
      </div>
    ))}
  </>
);
